var installedModules = {};
var moduleToHandlerMapping = {
	7046: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Observable_js"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_untracked-BKcld_ew_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	810: {
		getter: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 5689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	9980: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 2867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	2934: {
		getter: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_cv-mf_sudoku-types_cv-mf_sudoku-types"), __webpack_require__.e("libs_shared_sudoku_services_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @cv-mf/sudoku-services */ 6668))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-services",
	},
	9534: {
		getter: () => (__webpack_require__.e("libs_shared_sudoku_types_src_index_ts").then(() => (() => (__webpack_require__(/*! @cv-mf/sudoku-types */ 4531))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-types",
	},
	6717: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_cv-mf_sudoku-services_cv-mf_sudoku-services"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @cv-mf/angular-context-store */ 3904))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/angular-context-store",
	},
	5241: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @cv-mf/angular-timer-store */ 7234))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/angular-timer-store",
	},
	8813: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @cv-mf/angular-field-store */ 5303))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/angular-field-store",
	},
	9124: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_Observable_js"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	1143: {
		getter: () => (__webpack_require__.e("libs_shared_remote-utils_src_index_ts").then(() => (() => (__webpack_require__(/*! @cv-mf/remote-utils */ 4026))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "auto",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/remote-utils",
	},
	5394: {
		getter: () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	8282: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lit_decorators_js-node_modules_lit_index_js"), __webpack_require__.e("default-libs_shared_sudoku_web-components_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @cv-mf/sudoku-web-components */ 6881))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-web-components",
	},
	3655: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @cv-mf/angular-sudoku-store */ 5838))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/angular-sudoku-store",
	},
	954: {
		getter: () => (Promise.all([__webpack_require__.e("default-node_modules_lit_decorators_js-node_modules_lit_index_js"), __webpack_require__.e("default-libs_shared_web-components_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @cv-mf/shared-web-components */ 7781))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/shared-web-components",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		7046
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		810,
		9980
	],
	"default-webpack_sharing_consume_default_cv-mf_sudoku-services_cv-mf_sudoku-services": [
		2934
	],
	"default-webpack_sharing_consume_default_cv-mf_sudoku-types_cv-mf_sudoku-types": [
		9534
	],
	"default-webpack_sharing_consume_default_cv-mf_angular-context-store_cv-mf_angular-context-store": [
		6717
	],
	"default-webpack_sharing_consume_default_cv-mf_angular-field-store_cv-mf_angular-field-store-w-cf2295": [
		5241,
		8813
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		9124
	],
	"default-webpack_sharing_consume_default_cv-mf_remote-utils_cv-mf_remote-utils-node_modules_an-636354": [
		1143,
		5394
	],
	"default-apps_sudoku_angular_src_app_components_index_ts": [
		8282,
		3655
	],
	"apps_sudoku_angular_src_app_app_sudoku-app_component_ts": [
		954
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}